export default class extends Controller {
  static targets = ['deletePromptTemplate'];

  openDeletePrompt(event) {
    event && event.preventDefault();
    this.hasDeletePromptTemplateTarget && App.Modal.open({ content: this.deletePromptTemplateTarget.innerHTML });
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/events/expanded-event-controller.js